<template>
  <div>
    <div>
      openid: {{openid}}
      <el-button v-show="openid" @click="wxLogout">退出</el-button>
      <!--<div>response: {{response}}</div>-->
      <!--<div>code: {{code}}</div>-->
    </div>
    <div v-show="openid">
      <div>technician: {{technician}}</div>
      <div v-show="openid && !technician">
        <el-input v-model="cellphone" style="width: 160px; margin: 8px 16px"></el-input>
        <el-button @click="bind">绑定</el-button>
      </div>
      <div v-show="technician">
        <el-button @click="unbind">解绑</el-button>
      </div>
    </div>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'
  import { bindOpenid, unbindOpenid } from '@/utils/request'

  export default {
    name: 'WxUserInfo',
    data () {
      return {
        code: '--',
        response: '--',
        technician: '',
        cellphone: ''
      }
    },
    created () {
      if (!this.openid) {
        const code = this.$route.query.code
        this.code = code
        if (code) {
          this.response = '---'
          this.$store.dispatch('wxuser/wxLogin', code).then(response => {
            this.response = response
            // getTechnicianByOpenid(this.openid).then(response => {
            //   this.technician = response.data
            // })
          })
        } else {
          const url = encodeURIComponent(window.location.href)
          const newUrl = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=wx09939fb6a591cb27&redirect_uri=${url}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
          // 网页登陆 需要开放平台账号 https://developers.weixin.qq.com/doc/oplatform/Third-party_Platforms/2.0/product/Third_party_platform_appid.html
          // const newUrl = `https://open.weixin.qq.com/connect/qrconnect?appid=wxbbf90b94fd2b841a&redirect_uri=${url}&response_type=code&scope=snsapi_login&state=STATE#wechat_redirect`
          window.location.replace(newUrl)
        }
      } else {
        // getTechnicianByOpenid(this.openid).then(response => {
        //   this.technician = response.data
        // })
      }
    },
    methods: {
      wxLogout () {
        this.$store.dispatch('wxuser/wxLogout')
      },
      bind () {
        bindOpenid(this.cellphone, this.openid).then(response => {
          this.technician = response.data
        })
      },
      unbind () {
        unbindOpenid(this.technician.cellphone, this.openid).then(() => {
          this.technician = null
        })
      }
    },
    computed: {
      ...mapGetters([
        'openid'
      ])
    }
  }
</script>

<style scoped>

</style>
